<template>
  <div>
    <h3 class="text-success">{{ $t("global.use") }}:</h3>
    <ul>
      <li>{{ $t("global.long-passwords") }}</li>
      <li>{{ $t("global.lastpass-or-password-generator") }}</li>
      <li>{{ $t("global.password-suggestions") }}</li>
    </ul>
    <h3 class="text-danger">{{ $t("global.do-not-use") }}:</h3>
    <ul>
      <li>{{ $t("global.short-password") }}</li>
      <li>{{ $t("global.repeated-password") }}</li>
      <li>{{ $t("global.other-site-password") }}</li>
      <li>{{ $t("global.easy-password") }}</li>
      <li>{{ $t("global.common-password") }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PasswordTips",
  components: {},
  props: {},
  setup() {},
};
</script>
